import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextFieldMUI from 'material-ui/TextField';

export default class ReadOnlyTextField extends Component {

  select = () => {
    this.refs.textField.select();
  };

  render() {
    return (
      <TextFieldMUI
        underlineFocusStyle={{display: 'none'}}
        underlineStyle={{display: 'none'}}
        readOnly
        spellCheck={false}
        floatingLabelStyle = {{whiteSpace: 'nowrap'}}
        {...this.props}
        ref = "textField"

      />
    );
  }
}

ReadOnlyTextField.propTypes = {
  value: PropTypes.string.isRequired,
  floatingLabelText: PropTypes.string.isRequired,
};